import { Dialog, DialogTitle, DialogContent, DialogActions, Divider } from "@mui/material";
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import VuiButton from "components/VuiButton";
import { PERMISSION_SCREENS } from "variables";

const ACTIONS = ["view", "edit", "delete"];

const ViewRoleDialog = ({ open, onClose, role }) => {
  if (!role) return null;

  const { title, permissions = {} } = role;

  const hasPermission = (action, screen) => Boolean(permissions[`${action}${screen}`]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      {/* <DialogTitle>
        <VuiTypography variant="lg"  fontWeight="bold">
          Role Details
        </VuiTypography>
      </DialogTitle> */}

      <DialogContent>
        <VuiBox
          mb={4}
          //   p={2.5}
          borderRadius="lg"
          sx={({ palette }) => ({
            background: palette.gradients.card,
          })}
        >
          <VuiTypography variant="caption">Role Title</VuiTypography>
          <VuiTypography variant="h5" fontWeight="">
            {title}
          </VuiTypography>
        </VuiBox>

        <VuiTypography variant="h5" mb={2} fontWeight="regular">
          Permissions Access
        </VuiTypography>

        <VuiBox display="grid" gridTemplateColumns="repeat(2, 1fr)" gap={2}>
          {PERMISSION_SCREENS.map(({ key, label }) => {
            const visibleActions = ACTIONS.filter((a) => hasPermission(a, key));

            if (!visibleActions.length) return null;

            return (
              <VuiBox key={key} p={1}>
                <VuiTypography variant="body2" fontWeight="regular" mb={1}>
                  {label}
                </VuiTypography>

                <VuiBox display="flex" gap={1} flexWrap="wrap">
                  {visibleActions.map((action) => (
                    <VuiBox
                      key={action}
                      px={1.5}
                      py={0.5}
                      borderRadius="xl"
                      sx={({ palette }) => ({
                        background: palette.success.main,
                        //   action === "view"
                        //     ? palette.info.main
                        //     : action === "edit"
                        //     ? palette.warning.main
                        //     : palette.error.main,
                        color: palette.white.main,
                        fontSize: "10px",
                        fontWeight: 600,
                        letterSpacing: "0.04em",
                      })}
                    >
                      {action.toUpperCase()}
                    </VuiBox>
                  ))}
                </VuiBox>
              </VuiBox>
            );
          })}
        </VuiBox>
      </DialogContent>
      <DialogActions>
        <VuiButton variant="outlined" color="primary" onClick={onClose} sx={{ px: 4 }}>
          Close
        </VuiButton>
      </DialogActions>
    </Dialog>
  );
};

export default ViewRoleDialog;
